import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HttpInterceptorProviders } from './interceptors';

@NgModule({
    declarations: [],
    imports: [CommonModule, RouterModule],
    providers: [HttpInterceptorProviders, provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return { ngModule: CoreModule };
    }
}
